import React, { useState } from 'react';

function InteractiveDemo() {
    const [activeTab, setActiveTab] = useState(0);

    const tabs = [
        {
            title: 'Customer Care',
            heading: 'Customer Care Impact',
            description: 'Every ping, every email, every missed call handled in under 30 minutes. Our AI + human hybrid team manages 10,000+ conversations monthly while maintaining your exact brand voice. Guests feel heard. Staff stays focused on in-person service.',
            metrics: [
                { value: '94%', label: 'Guest Satisfaction Score' },
                { value: '18min', label: 'Average Response Time' },
                { value: '+31%', label: 'Positive Review Growth' },
                { value: '24/7', label: 'Coverage, Zero Gaps' }
            ]
        },
        {
            title: 'OTA Management',
            heading: 'OTA Management Results',
            description: 'Daily optimization across Booking.com, Expedia, and 15+ OTAs. We maintain rate parity, test promotional strategies, refresh content, and use AI to dynamically adjust pricing based on your comp set and local demand patterns.',
            metrics: [
                { value: '98%+', label: 'Parity Uptime' },
                { value: '+20%', label: 'Direct Bookings' },
                { value: '$110K', label: 'Annual Savings' },
                { value: '#3', label: 'Booking.com Rank' }
            ]
        },
        {
            title: 'Social Media',
            heading: 'Social Media Growth',
            description: 'Transform abandoned social channels into direct-booking engines. Automated posting, occupancy-triggered flash sales, and geo-targeted campaigns that bring guests straight to your website.',
            metrics: [
                { value: '71', label: 'Monthly Bookings' },
                { value: '+340%', label: 'Engagement Rate' },
                { value: '$89K', label: 'New Annual Revenue' },
                { value: '12-16', label: 'Posts Monthly' }
            ]
        },
        {
            title: 'Email Marketing',
            heading: 'Email Marketing Performance',
            description: 'Replace passive marketing with proactive revenue generation. Targeted campaigns for past guests, personalized cold outreach to corporate clients, and direct calls to event planners.',
            metrics: [
                { value: '68%', label: 'Weekday Occupancy' },
                { value: '25%+', label: 'Open Rate' },
                { value: '$340K', label: 'Additional Revenue' },
                { value: '3%+', label: 'Click-Through Rate' }
            ]
        },
        {
            title: 'Software',
            heading: 'Software Development Impact',
            description: 'Lightning-fast booking engines, guest apps, maintenance trackers, staff dashboards, all integrated with your PMS. Mobile-first design that converts.',
            metrics: [
                { value: '42%', label: 'Conversion Rate' },
                { value: '<2.5s', label: 'Load Time' },
                { value: '+30%', label: 'Mobile Bookings' },
                { value: '$215K', label: 'Revenue Increase' }
            ]
        },
        {
            title: 'Analytics',
            heading: 'Analytics Dashboard Value',
            description: 'One dashboard. Every metric. Real-time. See RevPAR, ADR, CSAT, social engagement, staff performance all in one place with AI recommendations.',
            metrics: [
                { value: '100%', label: 'Data Unified' },
                { value: 'Real-time', label: 'Updates' },
                { value: 'AI', label: 'Recommendations' },
                { value: 'Daily', label: 'Automated Reports' }
            ]
        },
        {
            title: 'Recruiting',
            heading: 'Recruiting Transformation',
            description: 'End the hiring headache. Multi-platform candidate sourcing, structured interview processes, streamlined onboarding, and retention tracking tied to performance metrics.',
            metrics: [
                { value: '65%', label: 'Turnover Rate' },
                { value: '-115%', label: 'Turnover Reduction' },
                { value: '$220K', label: 'Annual Savings' },
                { value: '180→65', label: 'Turnover Drop' }
            ]
        }
    ];

    return (
        <section id="demo" className="interactive-demo">
            <div className="section-content">
                <h2 className="section-title">
                    See The <span className="highlight">Power</span> of Integration
                </h2>
                <p style={{ 
                    textAlign: 'center', 
                    fontSize: '1.3rem', 
                    maxWidth: '900px', 
                    margin: '0 auto 2rem', 
                    color: 'var(--text-secondary)', 
                    lineHeight: '1.8', 
                    fontWeight: '400' 
                }}>
                    Click through each service to see real impact metrics from hotels using Warp Mill.
                </p>
                
                <div className="demo-container">
                    <div className="tab-buttons">
                        {tabs.map((tab, index) => (
                            <button
                                key={index}
                                className={`tab-btn ${activeTab === index ? 'active' : ''}`}
                                onClick={() => setActiveTab(index)}
                            >
                                {tab.title}
                            </button>
                        ))}
                    </div>

                    {tabs.map((tab, index) => (
                        <div
                            key={index}
                            className={`tab-content ${activeTab === index ? 'active' : ''}`}
                        >
                            <h3 style={{ 
                                fontSize: '2rem', 
                                marginBottom: '1.5rem', 
                                color: 'var(--text-primary)', 
                                fontWeight: '700' 
                            }}>
                                {tab.heading}
                            </h3>
                            <p style={{ 
                                fontSize: '1.1rem', 
                                color: 'var(--text-secondary)', 
                                lineHeight: '1.8', 
                                marginBottom: '2rem', 
                                fontWeight: '400' 
                            }}>
                                {tab.description}
                            </p>
                            <div className="metric-display">
                                {tab.metrics.map((metric, metricIndex) => (
                                    <div key={metricIndex} className="metric">
                                        <div className="metric-value">{metric.value}</div>
                                        <div className="metric-label">{metric.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default InteractiveDemo;

